'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'duck';
var width = 512;
var height = 512;
var aliases = [129414];
var unicode = 'f6d8';
var svgPathData = 'M250.8 272.4L104.3 325.2l-17.8 6.4-17.4-7.4-18.3-7.9C63.9 382.3 122.1 432 192 432l120 0c44.2 0 80-35.8 80-80l0-12.8c0-22.4-9.2-42.8-24.4-57.5L352 266.6l0-42.3 19.8-15.2C389 195.9 400 175.3 400 152c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 17.1 5.9 32.8 15.9 45.1l16.1 20 0 41.9-37.2 13.4zM32 256l16 6.9L88 280l99.5-35.8 47-16.9c-10.1-12.5-17.7-27.1-22.1-43C209.5 174 208 163.2 208 152c0-66.3 53.7-120 120-120c60.8 0 111 45.2 118.9 103.9l1.1 .1 64-8 0 8c0 52.5-42.2 95.2-94.5 96c-5 5.6-10.5 10.7-16.4 15.3c9 8.7 16.8 18.8 22.9 29.8c10.3 18.5 16.1 39.7 16.1 62.2l0 12.8c0 70.7-57.3 128-128 128l-120 0C91.3 480 8.8 402.6 .7 304c-.4-5.3-.7-10.6-.7-16l0-32 32 0zM344 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM231.5 353.7c22.7-5.7 38.1-24 40.8-44l47.6 6.3c-5.3 39.8-35.2 73.9-76.7 84.2c-34.1 8.5-68.6-.8-92.8-22.3l31.9-35.9c12.5 11.1 30.7 16.2 49.3 11.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDuck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;